import { HoldingsComponentDCR } from '@ddt-web/config';

import { PORTFOLIO_TYPE_TAG_TITLE, PORTFOLIO_TYPE_TAGS_KEY } from '../constants/portfolio-tag-config.constants';
import { PortfolioTagConfigResponse, PortfolioTagResponse, PortfolioTagsReportsResponse } from '../models/portfolio-tag-config-response.model';
import { PortfolioTag, PortfolioTagConfig, PortfolioTagGroup } from '../models/portfolio-tag-config.model';
import { SupportedPortfolioTag } from '../models/supported-portfolio-tags.model';


export function mapPortfolioTagResponseToPortfolioTagConfig(response: PortfolioTagConfigResponse, supportedPortfolioTags: SupportedPortfolioTag[], configPortfolioTypeOptions: string[]): PortfolioTagConfig {
	const report: PortfolioTagsReportsResponse = response?.resultMap?.REPORT[0];

	const tagGroupMap = new Map<string, PortfolioTagGroup>();
	if (report?.success) {
		Object.entries(report.data).forEach(([tagGroupKey, tagGroupResponse]) => {
			// Ignore type field
			if (isKeySupported(tagGroupKey, supportedPortfolioTags)) {
				const supportedPortfolioTag = supportedPortfolioTags.find(supportedPortfolioTag => isKeySupportedAndVisible(supportedPortfolioTag, tagGroupKey));
				tagGroupMap.set(
					tagGroupKey,
					mapTagGroupResponseToTagGroup(
						tagGroupKey,
						tagGroupResponse.tagGroupName,
						supportedPortfolioTag,
						tagGroupResponse.tagList.map(mapTagResponsesToTag)
					)
				);
			}
		});
		const portfolioTypeTag = supportedPortfolioTags.find(supportedTag => supportedTag.tagKey === PORTFOLIO_TYPE_TAGS_KEY);
		if (portfolioTypeTag) {
			tagGroupMap.set(
				PORTFOLIO_TYPE_TAGS_KEY,
				mapTagGroupResponseToTagGroup(
					PORTFOLIO_TYPE_TAGS_KEY,
					PORTFOLIO_TYPE_TAG_TITLE,
					portfolioTypeTag,
					mapConfigPortfolioTypeOptionsToPortfolioTagList(configPortfolioTypeOptions)
				)
			);
		}
	}
	return <PortfolioTagConfig>{
		tagGroupsMap: tagGroupMap
	};
}

function isKeySupported(tagGroupKey: string, supportedPortfolioTags: SupportedPortfolioTag[]): boolean {
	return tagGroupKey !== '@type' &&
		supportedPortfolioTags.some(supportedPortfolioTag => isKeySupportedAndVisible(supportedPortfolioTag, tagGroupKey));
}

function isKeySupportedAndVisible(supportedPortfolioTag: SupportedPortfolioTag, tagGroupKey: string): boolean {
	return supportedPortfolioTag.tagKey === tagGroupKey && supportedPortfolioTag.isVisible;
}

export function mapTagGroupResponseToTagGroup(tagGroupKey: string, tagGroupName: string, supportedPortfolioTag: SupportedPortfolioTag, tagList: PortfolioTag[]): PortfolioTagGroup {
	return <PortfolioTagGroup>{
		tagGroupKey: tagGroupKey,
		tagGroupName: tagGroupName,
		tagList: tagList,
		order: supportedPortfolioTag.order,
		unsupportedPortfolioTypes: supportedPortfolioTag.unsupportedPortfolioTypes ?? [],
		badgePrefixDefault: supportedPortfolioTag.badgePrefixDefault ?? '',
		noOfColumns: supportedPortfolioTag.noOfColumns ?? 1,
		type: supportedPortfolioTag.type ?? 'radio'
	};
}

export function mapTagResponsesToTag(tagResponse: PortfolioTagResponse): PortfolioTag {
	return <PortfolioTag>{
		key: tagResponse.key,
		label: tagResponse.label
	};
}

export function mapConfigPortfolioTypeOptionsToPortfolioTagList(configPortfolioTypeOptions: string[]): PortfolioTag[] {
	return configPortfolioTypeOptions.map(option =>
		<PortfolioTag>{
			key: option,
			label: HoldingsComponentDCR.PORTFOLIO_TYPE_OPTIONS[option]
		}
	);
}
